import { createSelector } from '@reduxjs/toolkit';
import { FOfferType } from '../../../../packages/JsonQuery';
import { selectOfferType } from 'shared/selectors/jsonQuery';

export const selectHouseAreaAvailable = createSelector(
  selectOfferType,
  offerType => (offerType & ~FOfferType.Land) !== 0,
);
